"use client";


import {SelectGlobalStyle} from "@/styles/SelectGlobalStyle";
import GlobalStyle from "@/styles/GlobalStyle";
import styled from "styled-components";
import Header from "@/components/layout/Header";
import Modal from "@/components/modal";
import Confirm from "@/components/confirm";
import SideNav from "@/components/layout/SideNav";
import Footer from "@/components/layout/Footer";
import FloatButton from "@/components/FloatButton";
import GlobalLoading from "@/components/common/GlobalLoading";
import { usePathname } from "@/i18n/navigation";
import {useGetLanguageQuery} from "@/api/languageApi";
import {useLocale} from "next-intl";
import {useEffect} from "react";
import {setLanguage} from "@/redux/languageSlice";
import {useDispatch} from "react-redux";
import {NOT_ALLOW_LANG} from "@/components/constants";

const ClientRoot = ({ children }) => {
    const pathName = usePathname();
    const locale = useLocale();
    const dispatch = useDispatch();
    const { data: langData, isLoading } = useGetLanguageQuery({ page: pathName, locale });
    useEffect(() => {
        if (!isLoading && langData && langData.result) {
            dispatch(setLanguage(langData.data));
        }
    }, [langData, isLoading]);
    return (
        <>
            <GlobalStyle />
            <SelectGlobalStyle />
            <Header />
            <SideNav />
            <RootInner>{children}</RootInner>
            <Footer />
            <Modal />
            <Confirm />
            <GlobalLoading />
        </>
    );
}

const RootInner = styled.div`
    margin-top: 80px;
`

export default ClientRoot








